import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const RegisterForm = ({ 
  formData, 
  errors, 
  isLoading, 
  onInputChange, 
  onSubmit,
  onGoogleAuth 
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-5">
      <Button
        type="button"
        variant="outline"
        fullWidth
        onClick={onGoogleAuth}
        disabled={isLoading}
      >
        <Icon name="Chrome" size={20} className="mr-2" />
        Sign up with Google
      </Button>
      
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-card text-muted-foreground">Or register manually</span>
        </div>
      </div>
      
      <Input
        label="Company Name"
        type="text"
        name="companyName"
        value={formData?.companyName}
        onChange={onInputChange}
        placeholder="Your Company Inc."
        error={errors?.companyName}
        required
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Input
          label="First Name"
          type="text"
          name="firstName"
          value={formData?.firstName}
          onChange={onInputChange}
          placeholder="John"
          error={errors?.firstName}
          required
        />
        <Input
          label="Last Name"
          type="text"
          name="lastName"
          value={formData?.lastName}
          onChange={onInputChange}
          placeholder="Doe"
          error={errors?.lastName}
          required
        />
      </div>
      <Input
        label="Email Address"
        type="email"
        name="email"
        value={formData?.email}
        onChange={onInputChange}
        placeholder="partner@company.com"
        error={errors?.email}
        required
      />
      <Input
        label="Phone Number"
        type="tel"
        name="phone"
        value={formData?.phone}
        onChange={onInputChange}
        placeholder="(555) 123-4567"
        error={errors?.phone}
        required
      />
      <Input
        label="Password"
        type="password"
        name="password"
        value={formData?.password}
        onChange={onInputChange}
        placeholder="Minimum 8 characters"
        description="Must contain at least 8 characters"
        error={errors?.password}
        required
      />
      <Input
        label="Confirm Password"
        type="password"
        name="confirmPassword"
        value={formData?.confirmPassword}
        onChange={onInputChange}
        placeholder="Re-enter your password"
        error={errors?.confirmPassword}
        required
      />
      <div className="space-y-3 pt-2">
        <Checkbox
          label={
            <span className="text-sm">
              I agree to the{' '}
              <a href="#" className="text-primary hover:text-primary/80 font-medium">
                Terms of Service
              </a>
              {' '}and{' '}
              <a href="#" className="text-primary hover:text-primary/80 font-medium">
                Privacy Policy
              </a>
            </span>
          }
          checked={formData?.agreeToTerms}
          onChange={onInputChange}
          name="agreeToTerms"
          error={errors?.agreeToTerms}
          required
        />
      </div>
      <Button
        type="submit"
        variant="default"
        fullWidth
        loading={isLoading}
        iconName="UserPlus"
        iconPosition="left"
      >
        {isLoading ? 'Creating account...' : 'Create Account'}
      </Button>
    </form>
  );
};

export default RegisterForm;